import React from 'react';

const availabilityKey = 'jema.calls.availability';
const availabilityEvent = 'jema:calls-availability-changed';

export type CallAvailability = 'online' | 'offline';

const readAvailability = (): CallAvailability => {
  if (typeof window === 'undefined') return 'online';
  return window.localStorage.getItem(availabilityKey) === 'offline' ? 'offline' : 'online';
};

export function setStoredCallAvailability(value: CallAvailability) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(availabilityKey, value);
  window.dispatchEvent(new CustomEvent(availabilityEvent, { detail: value }));
}

export function useCallAvailability() {
  const [availability, setAvailability] = React.useState<CallAvailability>(() =>
    readAvailability()
  );

  React.useEffect(() => {
    const handleChange = () => setAvailability(readAvailability());
    window.addEventListener('storage', handleChange);
    window.addEventListener(availabilityEvent, handleChange);
    return () => {
      window.removeEventListener('storage', handleChange);
      window.removeEventListener(availabilityEvent, handleChange);
    };
  }, []);

  const setOnline = React.useCallback((isOnline: boolean) => {
    setStoredCallAvailability(isOnline ? 'online' : 'offline');
  }, []);

  return {
    availability,
    isOnline: availability === 'online',
    setOnline,
  };
}
